import { Alert, Autocomplete, Button, Card, CardContent, CardHeader, Collapse, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import Adquisicion from "./Adquisicion";
import Factura from "./Factura";
import Viaticos from "./Viaticos";
import { useParams } from "react-router-dom";
import AsistenciaEventos from "./AsistenciaEventos";
import GastosViaje from "./GastosViaje";
import Conferenciante from "./Conferenciante";
import ValeCaja from "./ValeCaja";
import CompraLibros from "./CompraLibros";
import ServiciosProfesionales from "./ServiciosProfesionales";
import Reembolso from "./Reembolso";
import ValeDefinitivo from "./ValeDefinitivo";
import Comprobante from "./Comprobante";
import jwt_decode from "jwt-decode";
import ReembolsoPartida from "./ReembolsoPartida";
import GastosViajePartidas from "./GastosViajePartidas";
import Contrato from "./Contrato";
import DocumentosAdjuntosSolicitudGuardados from "./DocumentosAdjuntosSolicitudGuardados";
import DocumentosAdjuntosFormulario from "./DocumentosAdjuntosFormulario";
import OpenInNewTwoToneIcon from '@mui/icons-material/OpenInNewTwoTone';
import Transferencias from "./Transferencias";
import TransferenciaServicio from "./TransferenciaServicio";
import ViaticosPartidas from "./ViaticosPartidas";
import AEventosPartidas from "./AEventosPartidas";
import ConferenciantePartidas from "./ConferenciantePartidas";
import { Box } from "@mui/system";

const options = [{ id: 'adquisiciones', label: 'Adquisiciones' }, { id: 'asistenciaEventos', label: 'Asistencia a eventos' }, { id: 'aePartida', label: 'Asistencia a eventos con comprobante (más de una partida)' }, { id: 'compraLibros', label: 'Compra de libros y revistas' }, { id: 'comprobante', label: 'Comprobante' }, { id: 'conferenciante', label: 'Conferenciante invitado' }, { id: 'conferenciantePartida', label: 'Conferenciante invitado con comprobante (más de una partida)' },
{ id: 'gastosViaje', label: 'Gastos de viaje' }, { id: 'gastosViajePartida', label: 'Gastos de viaje con comprobante (más de una partida)' }, { id: 'facturas', label: 'Pago de factura' }, { id: 'contrato', label: 'Pago por contrato' }, { id: 'serviciosProfesionales', label: 'Pago único de servicios profesionales' }, { id: 'reembolso', label: 'Reembolso' }, { id: 'reembolsoCajaChica', label: 'Reembolso caja chica' }, /*{ id: 'transferencia', label: 'Transferencia (una sola partida de destino)' },*/ { id: 'transferencias', label: 'Transferencia' }, /*{ id: 'transferenciaservicio', label: 'Transferencia por servicio' },*/ { id: 'valeCaja', label: 'Vale de caja' }, { id: 'valeDefinitivo', label: 'Vale definitivo' }, { id: 'viaticos', label: 'Viáticos' }, { id: 'viaticosPartida', label: 'Viáticos con comprobante (más de una partida)' }]

export default function Servicio() {
    const [value, setValue] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [tipoServicio, setTipoServicio] = useState(null);
    const [matricula, setMatricula] = useState(null)
    const [idSolicitud, setIdSolicitud] = useState(null);
    const [idInforme, setIdInforme] = useState(null);
    const [idOficio, setIdOficio] = useState(null);
    const [idConcepto, setIdConcepto] = useState(null);
    const [tipoDocumento, setTipoDocumento] = useState(null)
    const [seEnviaCorreo, setSeEnviaCorreo] = useState(true);
    const [openDocumentos, setOpenDocumentos] = useState(false)
    const [documentosGuardados, setDocumentosGuardados] = useState([])
    const [entidades, setEntidades] = useState([])
    const [evaluacionesCompletas, setEvaluacionesCompletas] = useState(true)
    const [mensaje, setMensaje] = useState('')
    const params = useParams()
    let token = sessionStorage.getItem('token')
    let decoded = token ? jwt_decode(token) : null;

    let idLogueado = decoded ? decoded.id : null;

    const handleOpenDocumentos = async (idSolicitud) => {
        setOpenDocumentos(true)
        //setSolicitud(solicitud)
        const resDocumentos = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/documentosSolicitud/${idSolicitud}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })

        const documentos = await resDocumentos.json()
        setDocumentosGuardados(documentos)
    }
    /** Esta función determina si se deben hacer validaciones de montos al registrar una solicitud
     *  Las coordinaciones, RUL y SUL no deben tener estas validaciones pues cuentan con los reportes de saldos
     */
    const verificarDisponible = () => {
        const idEntidad = sessionStorage.getItem('idEntidad')
        const idEntidadSuperior = sessionStorage.getItem('idEntidadSuperior')
        if (Number(idEntidad) === Number(1) || Number(idEntidad) === Number(2) || Number(idEntidadSuperior) === Number(1) || Number(idEntidadSuperior) === Number(2)) {
            return false
        }
        return true
    }

    const cargarStorage = async () => {
        if (params.idUsuario) {
            const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT_LOGIN}/usuarios/storageEmpleado/${params.idUsuario}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            }

            )
            if (res.status === 404) {
                console.log('regresó 404 No hay sesión iniciada')
                // return { idPlanPresupuestal: 0, montoMaximo: 0 }
            }
            else {
                const data = await res.json()
                //console.log(`la sesión existe ${JSON.stringify(data)}`)

                Object.entries(JSON.parse(data.storage)).forEach(([key, value]) => {
                    sessionStorage.setItem(key, value)

                })


            }
        }
    }


    useEffect(() => {
        (async () => {

            await cargarStorage()
            token = sessionStorage.getItem('token')
            decoded = jwt_decode(token);
            idLogueado = decoded ? decoded.id : null;

            if (params.tipo) {
                setValue(params.tipo)
                setTipoServicio(params.tipo)
                if (params.idSolicitud)
                    setIdSolicitud(params.idSolicitud)
                if (params.matricula)
                    setMatricula(params.matricula)
                if (params.idInforme)
                    setIdInforme(params.idInforme)
                if (params.tipoDocumento)
                    setTipoDocumento(params.tipoDocumento)
                if (params.idOficio)
                    setIdOficio(params.idOficio)
                if (params.idConcepto)
                    setIdConcepto(params.idConcepto)
            }
        })();
    }, [params.tipo]
    )
    return (
        <Grid item xs={12} style={{ marginTop: 15 }}>
            <Card>

                <CardHeader title='Servicios' />

                <CardContent>
                    <Autocomplete disabled={idSolicitud || params.matricula ? true : false}
                        value={value}
                        onChange={async (event, newValue) => {
                            setValue(newValue);
                            console.log(newValue)
                            setTipoServicio(newValue ? newValue.id : null)
                            console.log(newValue ? newValue.id : null)
                            if (newValue && newValue.id === 'adquisiciones') {
                                const resPendientes = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT_ADQUISICIONES}/usuario/encuestasPendientes`, {
                                    method: "GET",
                                    headers: {
                                        "Content-Type": "application/json",
                                        "x-access-token": token,
                                        "perfil": sessionStorage.getItem('perfil')
                                    }
                                })
                                const pendientes = await resPendientes.json()
                                if (resPendientes.status === 200) {
                                    setEvaluacionesCompletas(true)
                                }
                                if (resPendientes.status === 404) {
                                    setEvaluacionesCompletas(false)
                                    setMensaje(`${pendientes.message} Por favor complete las evaluaciones pendientes en la aplicación ADQUISICIONES, no podrá registrar más solicitudes de adquisiciones hasta que todas las evaluaciones se hayan respondido.`)
                                }
                            }
                            if (newValue && newValue.id === 'transferenciaservicio') {
                                const resLeer = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/entidad/`, {
                                    method: "GET",
                                    headers: {
                                        "Content-Type": "application/json",
                                        "x-access-token": sessionStorage.getItem('token'),
                                        "perfil": sessionStorage.getItem('perfil')
                                    }
                                })
                                const entidadesLeidas = await resLeer.json()
                                const entidadesFiltradas = entidadesLeidas.filter(entidadF => Number(entidadF.id) !== Number(sessionStorage.getItem('idEntidad')))
                                //console.log(`entidadesLeidas ${JSON.stringify(entidadesLeidas)}`)
                                setEntidades(entidadesFiltradas)

                            }
                        }}

                        inputValue={inputValue}
                        onInputChange={(event, newInputValue) => {
                            setInputValue(newInputValue);
                        }}
                        id="tipo"
                        name="tipo"
                        options={options}
                        sx={{ width: 500 }}
                        renderInput={(params) => <TextField {...params} label="Tipo de servicio" focused />}
                    />
                    {/*<FormControlLabel
                        label={`Al concluir el registro de la solicitud deseo enviar un correo de notificación a la persona con perfil asistente${Number(sessionStorage.idTitularPerfil)!==Number(decoded.id) ? ' y a la persona titular':''}.`}
                        control={
                            <Checkbox
                                checked={seEnviaCorreo}
                                onChange={() => { setSeEnviaCorreo(!seEnviaCorreo) }}
                            />
                        }
                    />*/}
                    {/* OBSOLETA tipoServicio === 'transferencia' ?
                        <Transferencia idSolicitud={idSolicitud} seEnviaCorreo={seEnviaCorreo} setIdSolicitud={setIdSolicitud} verificarDisponible={verificarDisponible} /> : <></>
                    */}
                    {tipoServicio === 'transferencias' ?
                        <Transferencias idSolicitud={idSolicitud} seEnviaCorreo={seEnviaCorreo} setIdSolicitud={setIdSolicitud} verificarDisponible={verificarDisponible} /> : <></>
                    }
                    {tipoServicio === 'transferenciaservicio' ?
                        <>
                            <Autocomplete
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                getOptionLabel={(option) => option.nombre}
                                value={/*entidad ? entidad :*/ null}
                                onChange={async (event, newValue) => {
                                    //setEntidad(newValue)
                                    //console.log(`newValue ${JSON.stringify(newValue)}`)
                                    // console.log(`RESPONSABLE de entidad ${newValue?newValue.perfil.idEmpleado:newValue}`)

                                }
                                }
                                name="entidad"
                                options={entidades}
                                sx={{ width: '100%' }}
                                renderInput={(params) => <TextField {...params} label={`Entidad origen`} focused required multiline style={{ marginTop: 20 }} />}
                            />

                            <TransferenciaServicio idSolicitud={idSolicitud} seEnviaCorreo={seEnviaCorreo} setIdSolicitud={setIdSolicitud} verificarDisponible={verificarDisponible} />
                        </> : <></>
                    }
                    
                    {tipoServicio === 'adquisiciones' && evaluacionesCompletas ?
                        <Adquisicion idSolicitud={idSolicitud} seEnviaCorreo={seEnviaCorreo} setIdSolicitud={setIdSolicitud} verificarDisponible={verificarDisponible} /> : <></>
                        
                    }
                    {tipoServicio === 'adquisiciones' && !evaluacionesCompletas ?
                        <Box sx={{ width: '100%' }}>
                            <Collapse in={!evaluacionesCompletas}>
                                <Alert severity='error'                                   
                                    style={{ marginTop: 30 }}
                                >
                                    {mensaje}
                                </Alert>
                            </Collapse>
                        </Box> : <></>
                    }

                    {tipoServicio === 'viaticos' ?
                        <Viaticos idSolicitud={idSolicitud} seEnviaCorreo={seEnviaCorreo} setIdSolicitud={setIdSolicitud} verificarDisponible={verificarDisponible} /> : <></>
                    }
                    {tipoServicio === 'viaticosPartida' ?
                        <ViaticosPartidas idSolicitud={idSolicitud} seEnviaCorreo={seEnviaCorreo} setIdSolicitud={setIdSolicitud} verificarDisponible={verificarDisponible} /> : <></>
                    }

                    {tipoServicio === 'facturas' ?
                        <Factura idSolicitud={idSolicitud} seEnviaCorreo={seEnviaCorreo} setIdSolicitud={setIdSolicitud} verificarDisponible={verificarDisponible} /> : <></>
                    }

                    {tipoServicio === 'asistenciaEventos' ?
                        <AsistenciaEventos idSolicitud={idSolicitud} seEnviaCorreo={seEnviaCorreo} setIdSolicitud={setIdSolicitud} verificarDisponible={verificarDisponible} /> : <></>
                    }
                    {tipoServicio === 'aePartida' ?
                        <AEventosPartidas idSolicitud={idSolicitud} seEnviaCorreo={seEnviaCorreo} setIdSolicitud={setIdSolicitud} verificarDisponible={verificarDisponible} /> : <></>
                    }
                    {tipoServicio === 'gastosViaje' ?
                        <GastosViaje idSolicitud={idSolicitud} seEnviaCorreo={seEnviaCorreo} setIdSolicitud={setIdSolicitud} verificarDisponible={verificarDisponible} /> : <></>
                    }
                    {tipoServicio === 'gastosViajePartida' ?
                        <GastosViajePartidas idSolicitud={idSolicitud} seEnviaCorreo={seEnviaCorreo} setIdSolicitud={setIdSolicitud} verificarDisponible={verificarDisponible} /> : <></>
                    }
                    {tipoServicio === 'conferenciante' ?
                        <Conferenciante idSolicitud={idSolicitud} seEnviaCorreo={seEnviaCorreo} setIdSolicitud={setIdSolicitud} verificarDisponible={verificarDisponible} /> : <></>
                    }
                    {tipoServicio === 'conferenciantePartida' ?
                        <ConferenciantePartidas idSolicitud={idSolicitud} seEnviaCorreo={seEnviaCorreo} setIdSolicitud={setIdSolicitud} verificarDisponible={verificarDisponible} /> : <></>
                    }
                    {tipoServicio === 'valeCaja' ?
                        <ValeCaja idSolicitud={idSolicitud} seEnviaCorreo={seEnviaCorreo} setIdSolicitud={setIdSolicitud} verificarDisponible={verificarDisponible} /> : <></>
                    }
                    {tipoServicio === 'compraLibros' ?
                        <CompraLibros idSolicitud={idSolicitud} seEnviaCorreo={seEnviaCorreo} setIdSolicitud={setIdSolicitud} verificarDisponible={verificarDisponible} /> : <></>
                    }
                    {/* Servicios profesionales ya tiene para adjuntar documentos  */}
                    {tipoServicio === 'serviciosProfesionales' ?
                        <ServiciosProfesionales idSolicitud={idSolicitud} seEnviaCorreo={seEnviaCorreo} verificarDisponible={verificarDisponible} /> : <></>
                    }
                    {tipoServicio === 'reembolso' ?
                        <Reembolso idSolicitud={idSolicitud} seEnviaCorreo={seEnviaCorreo} setIdSolicitud={setIdSolicitud} verificarDisponible={verificarDisponible} /> : <></>
                    }
                    {tipoServicio === 'valeDefinitivo' ?
                        <ValeDefinitivo idSolicitud={idSolicitud} matricula={matricula} idInforme={idInforme} tipoDocumento={tipoDocumento} idOficio={idOficio} idConcepto={idConcepto} seEnviaCorreo={seEnviaCorreo} setIdSolicitud={setIdSolicitud} verificarDisponible={verificarDisponible} /> : <></>
                    }
                    {tipoServicio === 'comprobante' ?
                        <Comprobante idSolicitud={idSolicitud} seEnviaCorreo={seEnviaCorreo} setIdSolicitud={setIdSolicitud} verificarDisponible={verificarDisponible} /> : <></>
                    }
                    {tipoServicio === 'reembolsoCajaChica' ?
                        <ReembolsoPartida idSolicitud={idSolicitud} seEnviaCorreo={seEnviaCorreo} setIdSolicitud={setIdSolicitud} verificarDisponible={verificarDisponible} /> : <></>
                    }
                    {tipoServicio === 'contrato' ?
                        <Contrato idSolicitud={idSolicitud} seEnviaCorreo={seEnviaCorreo} setIdSolicitud={setIdSolicitud} verificarDisponible={verificarDisponible} /> : <></>
                    }

                    {idSolicitud ? <><Button variant='contained' style={{ marginTop: 20 }} color='secondary' size='small' type='button' onClick={() => handleOpenDocumentos(idSolicitud)}>
                        Añadir otros documentos <OpenInNewTwoToneIcon></OpenInNewTwoToneIcon>
                    </Button><Dialog open={openDocumentos} fullWidth={true}
                        maxWidth='xl' >

                            <DialogTitle>Añadir documentos a la solicitud</DialogTitle>
                            <DialogContent style={{ backgroundColor: '#FFFEED' }}>
                                <DocumentosAdjuntosSolicitudGuardados documentosGuardados={documentosGuardados} setDocumentosGuardados={setDocumentosGuardados}></DocumentosAdjuntosSolicitudGuardados>
                                <DocumentosAdjuntosFormulario idSolicitud={idSolicitud} idAutor={idLogueado} documentosGuardados={documentosGuardados} setDocumentosGuardados={setDocumentosGuardados}></DocumentosAdjuntosFormulario>
                                {/*<DocumentosAdjuntosSolicitud documentos={documentos} setDocumentos={setDocumentos} ventana={true}></DocumentosAdjuntosSolicitud>*/}
                            </DialogContent>
                            <DialogActions>
                                <Button variant='contained' style={{ backgroundColor: "darkgreen", color: 'white' }} onClick={() => { setOpenDocumentos(false) }}>Cerrar Ventana</Button>
                            </DialogActions>

                        </Dialog></> : <></>}

                </CardContent>
            </Card>
        </Grid>
    )
}